import { year } from '@jbc-year-end-adj/2024/consts';

export const ADMIN_ENDPOINT = `/graphql/${year}`;
export const EMPLOYEE_ENDPOINT = `/graphql/employee/${year}`;
